var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87508 13.0202L8.50008 11.4368L11.1251 13.041L10.4376 10.041L12.7501 8.04102L9.70841 7.77018L8.50008 4.93685L7.29175 7.74935L4.25008 8.02018L6.56258 10.041L5.87508 13.0202ZM3.35425 16.4993L4.70841 10.6452L0.166748 6.70768L6.16675 6.18685L8.50008 0.666016L10.8334 6.18685L16.8334 6.70768L12.2917 10.6452L13.6459 16.4993L8.50008 13.3952L3.35425 16.4993Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.393a52149e1cc1d5d44824885c946277.svg";
export { ForwardRef as ReactComponent };